module.exports = __webpack_public_path__ + "static/media/w (2).f29d1b49.jpg";